module.exports = __webpack_public_path__ + "static/media/trash.29b0492c.svg";